"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DivSafeZone = void 0;
var _react = _interopRequireWildcard(require("react"));
var _configProps = require("../../constants/configProps");
var _utilities = require("../../utilities/utilities");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var DivSafeZone = exports.DivSafeZone = function DivSafeZone(props) {
  var _props$count = props.count,
    count = _props$count === void 0 ? 3 : _props$count,
    id = props.id,
    className = props.className,
    configProps = props.configProps;
  var displayDivSafeZone = (0, _utilities.isYesOrTrue)(configProps[_configProps.ConfigProps.ActivateAdobeTargetDIVTagSafeZones]);
  var divSafeZoneIds = (0, _react.useMemo)(function () {
    var ids = [];
    for (var i = 0; i < count; i++) {
      ids.push("".concat(id, "-").concat(i + 1));
    }
    return ids;
  }, [count, id]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, displayDivSafeZone && divSafeZoneIds.map(function (divSafeZoneId) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      id: divSafeZoneId,
      className: className,
      key: divSafeZoneId
      // suppress hydration warnings because advertisements can alter the html before the app hydrates
      ,
      suppressHydrationWarning: true
      // dangerouslySetInnerHTML prevents hydration from clearing out advertisements
      ,
      dangerouslySetInnerHTML: {
        __html: ""
      }
    });
  }));
};
//# sourceMappingURL=divSafeZone.js.map